import * as React from 'react';
import { SvgProps } from './SvgGetter/SvgGetter';
import { Colors } from '../../../styles/colors';

export const Link: React.FC<SvgProps> = ({ fill = Colors.primaryTekst, opacity }) => (
	<svg
		width={16}
		height={16}
		viewBox='0 0 16 16'
		fill='none'
		opacity={opacity}
		xmlns='http://www.w3.org/2000/svg'
	>
		<path
			d='M13.515 9.74v4.074A2.206 2.206 0 0 1 11.33 16H2.186C.994 15.9 0 14.907 0 13.714V4.571C0 3.38.994 2.385 2.186 2.385h3.975c.398 0 .796.398.796.795 0 .398-.398.795-.796.795H2.186c-.397 0-.596.298-.596.596v9.243c0 .298.298.596.596.596h9.243c.298 0 .596-.298.596-.596V9.739c-.1-.497.298-.795.695-.795.398 0 .795.298.795.795ZM15.105 0h-4.869a.784.784 0 0 0-.795.795c0 .398.398.795.795.795h3.08L6.162 8.646a.76.76 0 0 0-.198.497c0 .199.1.397.198.596.2.1.398.199.597.199.199 0 .397-.1.596-.199l7.056-7.056v2.982c0 .397.397.795.795.795.397 0 .795-.398.795-.795V.795C15.9.398 15.503 0 15.106 0Z'
			fill={fill}
		/>
	</svg>
);
